import { useState } from "react";
import { Link } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err, "Errore invio email"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-zen-bg flex items-center justify-center px-6 py-12" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/brand/freelanzen-wordmark.png" alt="FreelanZen" className="h-10 w-auto object-contain"/>
        </Link>
        <div className="zen-card p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <CheckCircle2 size={40} className="mx-auto text-zen-primary mb-3"/>
              <h2 className="font-heading text-2xl mb-2">Controlla la tua email</h2>
              <p className="text-zen-ink2 text-sm">
                Se l&apos;indirizzo <b>{email}</b> è registrato, riceverai a breve un&apos;email con le istruzioni per reimpostare la password. Il link scade in 1 ora.
              </p>
              <Link to="/login" className="mt-6 inline-block text-zen-primary hover:underline text-sm">
                ← Torna al login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="font-heading text-2xl mb-1">Password dimenticata?</h2>
              <p className="text-zen-ink2 text-sm mb-6">Inserisci la tua email — ti invieremo un link per sceglierne una nuova.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email" data-testid="forgot-email" type="email" required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="tu@studio.it"
                    className="mt-1.5"
                  />
                </div>
                <Button
                  type="submit" disabled={loading} data-testid="forgot-submit"
                  className="w-full bg-zen-primary hover:bg-zen-primaryHover text-white rounded-full py-6"
                >
                  <Mail size={16} className="mr-2"/>
                  {loading ? "Invio…" : "Invia link di reset"}
                </Button>
              </form>
              <div className="mt-6 text-center text-sm">
                <Link to="/login" className="text-zen-ink2 hover:text-zen-primary inline-flex items-center gap-1">
                  <ArrowLeft size={12}/> Torna al login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
